export default __webpack_public_path__ + "static/media/group-org2.5f535d58.jpg";